"use client";

import { useEffect, useMemo } from "react";
import { ActionIcon, Box as MantineBox, Title as MantineTitle } from "@mantine/core";
import { useFiltersStore } from "@/stores/filtersStore";
import { useGlobalData } from "@/context/globalContext";
import useMostRecentViews from "@/hooks/useMostRecentViews";

import ReloadIcon from "@/icons/Reload";
import CardGrid from "@/components/CardGrid";

import styles from "./styles.module.scss";

const Spotlight = () => {
  const { mostRecent, fetchMostRecent, loading } = useMostRecentViews();
  const activeFilters = useFiltersStore((state) => state.activeFilters);
  const { exchangeRates } = useGlobalData();

  useEffect(() => {
    fetchMostRecent(50);
  }, [fetchMostRecent]);

  const convertedItems = useMemo(() => {
    if (!exchangeRates || !mostRecent.length) {
      return mostRecent;
    }

    const selectedCurrency = (activeFilters?.currency?.[0]?.value as string) || "USD";

    return mostRecent.map((item) => {
      if (item.currency === selectedCurrency) {
        return item;
      }

      if (exchangeRates[selectedCurrency]) {
        const convertedPrice = Math.floor(parseFloat(item.price) * exchangeRates[selectedCurrency]);
        return {
          ...item,
          price: convertedPrice.toString(),
          currency: selectedCurrency,
        };
      }

      return item;
    });
  }, [mostRecent, exchangeRates, activeFilters?.currency]);

  return (
    <MantineBox className={styles.spotlight}>
      <MantineBox className={styles.body}>
        <MantineBox className={styles.container} id="masonary">
          <MantineBox className={styles.header}>
            <MantineTitle order={1}>TRENDING NOW</MantineTitle>
            <ActionIcon
              onClick={() => fetchMostRecent(50)}
              className={styles.reloadButton}
              variant="subtle"
              size={44}
              disabled={loading}
              aria-label={loading ? "Refreshing trending listings" : "Refresh trending listings"}
              title="Refresh trending listings"
            >
              <ReloadIcon />
            </ActionIcon>
          </MantineBox>
          <CardGrid items={convertedItems} loading={loading} />
        </MantineBox>
      </MantineBox>
    </MantineBox>
  );
};

export default Spotlight;
